
import "@sparta.homepage.modules/header-module/dist/styles.css"
import "@sparta.homepage.modules/highlight-lowlight-legacy-module/dist/styles.css"
import "@sparta.homepage.modules/bmh-legacy-module/dist/styles.css"
import "@sparta.homepage.modules/news-information-legacy-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import homepageBootstrapUtility from "@sparta.homepage.utilities/homepage-bootstrap-utility/dist/es6.js"
import syncAlloyUtility from "@sparta.global-vtim.utilities/sync-alloy-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import alloyBootstrapUtility from "@sparta.homepage.utilities/alloy-bootstrap-utility/dist/es6.js"

import "@sparta.homepage.modules/header-module/dist/es6.js"
import "@sparta.homepage.modules/highlight-lowlight-legacy-module/dist/es6.js"
import "@sparta.homepage.modules/bmh-legacy-module/dist/es6.js"
import "@sparta.homepage.modules/news-information-legacy-module/dist/es6.js"
import "@sparta.sales.modules/ap-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init();
homepageBootstrapUtility.init();
alloyBootstrapUtility.init();
  console.log('after - execute boot functions')
})();
